import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle";
import CertificateCheckpage from "../../components/CertificateCheckpage";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";

const CertificateCheckPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={"Certificate Verification"} pagesub={"Verify"} />
      <CertificateCheckpage />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CertificateCheckPage;
